module.exports = __webpack_public_path__ + "static/img/testtitbg.c055399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testtitbg.png?v=1
// module id = SkZC
// module chunks = 1